import React from 'react';

import { ContactEntity } from '~/components/Contact';
import { ErrorHelperTextFormik } from '~/components/core/Formik/ErrorHelperTextFormik';
import Caption from '~/components/core/TextComponents/Caption';
import Text from '~/components/core/TextComponents/Text';
import type { MoiAutomaticRulesAssignee } from '~/components/exposures/moi/MoiStepper/types';

interface AutomaticRulesAssigneeFieldProps {
  automaticRulesAssignee?: MoiAutomaticRulesAssignee | null;
}

const AutomaticRulesAssigneeField: React.FC<AutomaticRulesAssigneeFieldProps> = ({ automaticRulesAssignee }) => {
  const contact = automaticRulesAssignee?.contact;

  return (
    <>
      <Caption variant={Caption.VARIANTS.LABEL} className="mb-4">
        Service Provider
      </Caption>
      {contact ? (
        <ContactEntity contactId={contact.id} contactDisplayName={contact.full_name ?? ''} maxWidth="100%" />
      ) : (
        <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
          {automaticRulesAssignee?.unavailable_reason ?? ''}
        </Text>
      )}
      <ErrorHelperTextFormik className="mt-2" id="contact_id" />
    </>
  );
};

export default AutomaticRulesAssigneeField;
